export default __webpack_public_path__ + "static/media/warning-icon.5a117ae3.svg";